<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" :fill="fill" xmlns="http://www.w3.org/2000/svg" :style="{'fill':isFill? '#80B7FF': 'none'}">
    <path
      d="M17.4394 12.6836C17.3377 12.9886 17.3888 13.3238 17.5767 13.5846C17.7647 13.8454 18.0665 14 18.388 14H24C24.5507 14 25 14.4493 25 15L25 17L25 17.0017L22.2448 24.3478C22.2447 24.3482 22.2445 24.3487 22.2443 24.3492C22.1718 24.5398 22.0433 24.704 21.8756 24.8202C21.708 24.9363 21.5091 24.999 21.3051 25H8C7.44928 25 7 24.5507 7 24V15C7 14.4493 7.44928 14 8 14H10.531C10.8278 14 11.1092 13.8682 11.2992 13.6402L15.9976 8.00217C15.9976 8.0021 15.9977 8.00203 15.9977 8.00197C15.9989 8.00059 15.9998 8.00015 16.0001 8.00002C16.0001 8.00001 16.0001 8.00001 16.0001 8H17.612C17.9318 8 18.2379 8.15667 18.4249 8.41592C18.6112 8.67431 18.6632 9.01322 18.562 9.31771L17.4394 12.6836Z"
      stroke="#80B7FF"
      stroke-width="2"
      :fill="fill"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
    props: {
        width: { type: [Number, String], default: 32 },
        height: { type: [Number, String], default: 32 },
        isFill: { type: Boolean, default: false }
    },
};
</script>

<style>
</style>